import {Button, Modal} from "react-bootstrap";
import ImageComponent from "../shared/ImageComponent";
import {baseImageUrl} from "../../../services/AxiosInstance";
import profileImage from "../../../images/profileImage.png";
import {Field, Formik} from "formik";
import * as Yup from "yup";
import {useAddReview} from "../../../hooks/useReview";
import {useAddTicket} from "../../../hooks/useTicket";
import {useUpdateIntervention} from "../../../hooks/useInterventions";
import {interventionStatus, userRoleList} from "../../../utils/constants";
import {useSelector} from "react-redux";

const CancelModal = ({openModal, toggleModal, intervention}) => {
  const {onUpdateIntervention} = useUpdateIntervention();
  const {selectedRole} = useSelector((state) => state.auth.auth);

  const handleSubmit = async (values) => {
    // Add your review submission logic here
    await onUpdateIntervention({
      id: intervention?.id,
      body: {
        status: interventionStatus.CANCELED,
        cancellationReason:
          values.reason === "Autre" ? values.autre : values.reason,
      },
    });
    toggleModal(false);
  };
  return (
    <Modal
      className="modal fade"
      show={openModal}
      onHide={toggleModal}
      centered
      size="md"
    >
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title text-[#1A64B9] font-semibold">
            Annuler l'intervention
          </h4>
          <Button
            variant=""
            type="button"
            className="close"
            onClick={() => toggleModal(false)}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !py-3 !px-0 h-fit max-h-[70vh] overflow-scroll overflow-style-none">
          <div className="w-full flex flex-col justify-center items-center gap-2 ">
            <div className="flex flex-col justify-center items-center ">
              <div
                className="text-base font-normal !px-6  text-[#19295C]
                text-center
                "
              >
                Veuillez indiquer la raison de l'annulation de l'intervention "
                {intervention?.title} "{" "}
              </div>
            </div>

            <Formik
              initialValues={{reason: "", autre: ""}}
              validationSchema={Yup.object({
                reason: Yup.string()
                  .required("La raison est requise")
                  .min(3, "La raison doit contenir au moins 3 caractères"),
                autre: Yup.string()
                  .when("reason", {
                    is: "Autre",
                    then: Yup.string()
                      .required("La raison est requise")
                      .min(3, "La raison doit contenir au moins 3 caractères"),
                  })
                  .nullable(),
              })}
              onSubmit={handleSubmit}
            >
              {({values, errors, touched, handleSubmit, setFieldValue}) => (
                <form onSubmit={handleSubmit} className="w-full">
                  <div className="w-full !px-6 !py-3">
                    <div className="form-group mb-4">
                      {selectedRole !== userRoleList.CLIENT ? (
                        <Field
                          type="select"
                          as="select"
                          className="form-control placeholder:text-sm"
                          name="reason"
                          placeholder="Raison..."
                        >
                          <option value="Client injoignable.">
                            Client injoignable.
                          </option>
                          <option value="Je suis pas disponible.">
                            Je suis pas disponible.
                          </option>
                          <option value="Autre">Autre</option>
                        </Field>
                      ) : (
                        <Field
                          type="select"
                          as="select"
                          className="form-control placeholder:text-sm custom-select-arrow"
                          name="reason"
                          placeholder="Raison..."
                        >
                          <option value="Je n'ai plus besoin de l'intervention.">
                            J'ai plus besoin de l'intervention.
                          </option>
                          <option value="Prestataire injoignable.">
                            Prestataire injoignable.
                          </option>
                          <option value="Je suis pas disponible.">
                            Je suis pas disponible.
                          </option>
                          <option value="Autre">Autre</option>
                        </Field>
                      )}

                      {errors.reason && touched.reason && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.reason}
                        </div>
                      )}
                    </div>
                    {values.reason === "Autre" && (
                      <div className="form-group mb-4">
                        <Field
                          type="text"
                          className="form-control placeholder:text-sm"
                          name="autre"
                          placeholder="Raison..."
                        />

                        {errors.autre && touched.autre && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.autre}
                          </div>
                        )}
                      </div>
                    )}

                    {selectedRole === userRoleList.CLIENT && (
                      <div className="text-[#3D4465] font-light text-[10px] mt-2 w-full text-left">
                        NB : le remboursement est de 100 % au moins 6 heures
                        avant le rendez-vous, 70 % entre 4 heures et moins de
                        6 heures, 50 % entre 2 heures et moins de 4 heures, et
                        0 % moins de 2 heures avant le rendez-vous.
                      </div>
                    )}

                    <div className="grid grid-cols-2 gap-2 mt-4">
                      <button
                        type="button"
                        onClick={() => toggleModal(false)}
                        className="!rounded-md  !py-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase"
                      >
                        Ignorer
                      </button>
                      <button
                        type="submit"
                        className="!rounded-md  !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm    uppercase"
                      >
                        Confirmer
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default CancelModal;
